// extracted by mini-css-extract-plugin
export default {"wrapper":"AppLayout_wrapper__JL24t","container":"AppLayout_container__E54xa","loader":"AppLayout_loader__ACW4I"};